import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useHistory} from "react-router-dom";
import moment from 'moment-timezone';
import axios from "axios";
import {IonBadge} from "@ionic/react";
import {
    StyledButton,
} from '@app/travelAllowance/travelAllowance.style';
import {Links} from "@app/links";
import StaticPane from "@components/pane/static-pane.component";
import useOffsetTop from "@hooks/useOffsetTop";
import {getReportApplications} from "@services/helpdesk/helpdesk.service";
import {StyledOrders} from "@app/mainPage/tabs/reports/panes/reports.style";
import {ReportApplicationStatus} from "@enums/reportApplicationStatus";
import {minutesToHoursMinutes} from "@utils/tools/time";

type RideListPaneProps = {
    topEdge?: number;
}

export type Application = {
    id: string,
    createdAt?: string,
    createdByProfile?: boolean,
    date: string,
    client: {
        id: number;
        name: string;
    };
    order: {
        id?: number;
        formatted_number?: string;
    };
    report: {
        id?: number;
        formatted_number?: string;
    };
    type: string,
    status: string,
    hours: string,
    comment_worker?: string,
}

const ReportApplicationListPane: React.FC<RideListPaneProps> = ({topEdge}: RideListPaneProps) => {
    const cancelToken = axios.CancelToken.source();

    const {t} = useTranslation();
    const history = useHistory();
    const {ref: boxRideRef, offsetTop} = useOffsetTop<HTMLDivElement>();

    const [loading, setLoading] = useState<boolean>(false);
    const [applications, setApplications] = useState<Application[]>([]);

    const [showLoader, setShowLoader] = useState<boolean>(false);


    useEffect(() => {
        setLoading(true);

        fetchApplications()
            .then(() => {
                setLoading(false);
            })
            .catch((e) => {
                console.error(e);
            });

    }, [history.location.pathname]);

    const fetchApplications = async () => {
        const applications = await getReportApplications();
        setApplications(applications);
    }

    const preview = (application: Application) => {
        history.push(Links.main + Links.helpdesk.reportApplicationPreview + '/' + application.id)
    }

    return (
        <StaticPane topEdge={topEdge} marginTop={40} paddingTop={30} paddingBottom={110} hideGrabber={true}>
            <section className="button-box">
                <StyledButton onClick={() => history.push(Links.main + Links.helpdesk.reportApplication)}>
                    <div className="btn center">
                        <span>{t('reportApplication.add')}</span>
                    </div>
                </StyledButton>
            </section>
            {
                <StyledOrders>
                    {
                        applications.map((application, index) => {
                                return <React.Fragment key={application.id || index}>
                                    <div className="order">
                                        <div className="order-number" onClick={async () => {
                                            preview(application)
                                        }}> {application.type == 'TOO_MANY_HOURS' ? t('report_application.type_to_many_hours') : t('report_application.type_too_few_or_no_hours')}
                                            <span>: </span> <br />
                                            <span style={{color: application.type != 'TOO_MANY_HOURS' ? 'green' : 'red'}}>
                                                  {minutesToHoursMinutes(parseInt(application.hours))}
                                            </span>
                                            {application.createdByProfile == true && <><br/><IonBadge
                                                color="primary"
                                                className="draft report-number">{t('report_application.created_by_coordinator')}</IonBadge></>}
                                            {application.status === ReportApplicationStatus.WAITING_FOR_KO && <>
                                                <br/><IonBadge
                                                color="warning"
                                                className="draft report-number">
                                                <span>{t('report_application.status_waiting_for_ko')}</span>
                                                </IonBadge></>}
                                            {application.status === ReportApplicationStatus.WAITING_FOR_RM && <>
                                                <br/><IonBadge
                                                color="warning"
                                                className="draft report-number">{t('report_application.status_waiting_for_rm')}</IonBadge></>}
                                            {application.status === ReportApplicationStatus.ACCEPTED && <><br/><IonBadge
                                                color="success"
                                                className="draft report-number">{t('report_application.status_accepted')}</IonBadge></>}
                                            {application.status === ReportApplicationStatus.REJECTED_BY_KO && <>
                                                <br/><IonBadge
                                                color="danger"
                                                className="draft report-number">{t('report_application.status_rejected_by_ko')}</IonBadge></>}
                                            {application.status === ReportApplicationStatus.REJECTED && <><br/><IonBadge
                                                color="danger"
                                                className="draft report-number">{t('report_application.status_rejected')}</IonBadge></>}
                                        </div>
                                        <div className="details">
                                            <div className="detail">
                                                {t('report_application.date')}<span>: </span>
                                                <span className="value">
                                                    {moment(application.date, moment.ISO_8601).format('DD-MM-YYYY')}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="details">
                                            <div className="detail">
                                                {t('report_application.client')}<span>: </span>
                                                <span className="value">
                                                    {application.client.name}
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                </React.Fragment>
                            }
                        )
                    }
                </StyledOrders>
            }
        </StaticPane>
    );
};

export default ReportApplicationListPane;